import { render, staticRenderFns } from "./BetPlacedAlertConfig.vue?vue&type=template&id=57043235&"
import script from "./BetPlacedAlertConfig.vue?vue&type=script&lang=js&"
export * from "./BetPlacedAlertConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports